import {
  GeoJsonFeature,
  GeoJsonLineString,
  GeoJsonMultiLineString,
  GeoJsonMultiPolygon
} from '@/interfaces/misc.interface'
import { getRequestGateway } from '@/services/api.service'

export type ZoneDto = {
  id: string
  categoryId: string
  coreId: string
  geometry: ZoneLayerDto[]
  realmId: string
  createdDate: string
  createdBy: string
  lastModifiedDate: string
  lastModifiedBy: string
  status: 'ACTIVE' | 'ARCHIVED'
}
export type ZoneLayerDto = {
  typeId: string
  geometry: GeoJsonMultiPolygon
  name?: string
}
export type ZoneLayer = {
  categoryId: string
  coreId: string
  geometry: GeoJsonLineString
  id: string
  name?: string
  realmId: string
  typeId: string
}
export type ZoneGeoJsonFeature = GeoJsonFeature<
  GeoJsonLineString | GeoJsonMultiLineString,
  ZoneProperties
>
export type ZoneProperties = {
  area: number
  categoryId: string
  centroid: GeoJSON.Point
  color: string
  id: string
  layerId?: string
  name: string
  typeId: string
  zoneId: string // use this to identify the zone, other id is BE specific it seems
}

export async function getZoneCategories(id: string) {
  return await getRequestGateway(`/zone/v1/categories?coreId=${id}&page=0&pageSize=100`)
}

export async function getZoneTypeFeaturesV2(
  coreId: string,
  categoryId: string,
  typeId: string
): Promise<ZoneGeoJsonFeature[] | undefined> {
  const endpoint = `/zone/v1/zones/geojson?coreId=${coreId}&categoryId=${categoryId}&typeId=${typeId}`
  const response = await getRequestGateway<ZoneGeoJsonFeature[]>(endpoint)
  return response?.data
}

// export async function getZoneTypeFeatures(coreId, categoryId) { - no longer used
//   return await getRequestGateway(`/zone/v1/zones/geojson?coreId=${coreId}&categoryId=${categoryId}`)
// }

export async function getZoneType(typeId: string) {
  return await getRequestGateway(`/zone/v1/zones/${typeId})`)
}
export async function getZoneSummaryForLevel(levelId: string): Promise<any> {
  const endpoint = `/zone/v1/zones/summary/${levelId}`
  const response = await getRequestGateway(endpoint)
  if (response) return response.data
}

export async function getZoneSummaryForConstruction(constructionId: string): Promise<any> {
  const endpoint = `/zone/v1/zones/summary/${constructionId}`
  const params = { coreType: 'CONSTRUCTION' }
  const response = await getRequestGateway(endpoint, 0, 1, params)
  if (response) return response.data
}

export async function getZoneSummaryForRealEstate(realEstateId: string): Promise<any> {
  const endpoint = `/zone/v1/zones/summary/${realEstateId}`
  const response = await getRequestGateway(endpoint)
  if (response) return response.data
}

export async function getZoneById(id: string): Promise<ZoneDto | undefined> {
  const endpoint = `/zone/v1/zones/${id}`
  const response = await getRequestGateway<ZoneDto>(endpoint)
  if (response) return response.data
}

export async function getZoneLayerById(id: string): Promise<ZoneLayer | undefined> {
  const endpoint = `/zone/v1/zones/layer/${id}`
  const response = await getRequestGateway<ZoneLayer>(endpoint)
  if (response) return response.data
  return undefined
}
